import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { User } from "../../../model/User";

export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";

export interface GetUserListSuccessAction extends Action {
  type: typeof GET_USER_LIST_SUCCESS;
  organization: OrganizationKeyName;
  nextPageUrl: string;
  hasMore: boolean;
  users: User[];
  totalCount: number;
}

export const getUserListSuccessAction = (
  users: User[],
  organization: OrganizationKeyName,
  nextPageUrl: string,
  totalCount: number,
  hasMore: boolean
): GetUserListSuccessAction => ({
  type: GET_USER_LIST_SUCCESS,
  organization,
  nextPageUrl,
  users,
  hasMore,
  totalCount,
});
